import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResGetDetailByArticalID {
  message: string;
  result: {
    HAVE_LOGIN: boolean;
    DETAIL_ARTICAL: [
      {
        ADMIN_CREATEID: {
          ADMIN_ID: string;
          USERNAME: string;
          IMG: string;
        }
        ALWAYS_OPEN: string;
        ARTICAL_CATEGORY: string;
        ARTICAL_CREATID: string;
        ARTICAL_DATE: Date;
        ARTICAL_DETAIL: string;
        ARTICAL_END: Date;
        ARTICAL_ID: string;
        ARTICAL_ORIGINAL: string;
        ARTICAL_PIC: string;
        ARTICAL_READED: number;
        ARTICAL_START: Date;
        ARTICAL_STATUS: number;
        ARTICAL_TITAL: string;
        CREATE_BY: string;
        POLL_ID: string;
      }
    ]
    DETAIL_POLL: [
      {
        ARTICAL_ID: string;
        CREATE_BY: string;
        CREATE_DATE: Date;
        POLL_END: Date;
        POLL_ID: string;
        POLL_QUESTION: string;
        POLL_START: Date;
        POLL_CHOICE: [
          {
            OPTION_ID: number;
            OPTION_VALUE: string;
            POLL_ID: string;
          }
        ]
      }
    ]
    SUGGEST_ARTICAL: [
      {

      }
    ]
  },
  success: true
}

export interface ResGetAllArticalByType {
  message: string;
  result: [
    {
      ALWAYS_OPEN: string;
      ARTICAL_CATEGORY: number;
      ARTICAL_CREATID: string;
      ARTICAL_DATE: Date;
      ARTICAL_DETAIL: string;
      ARTICAL_END: Date;
      ARTICAL_ID: string;
      ARTICAL_ORIGINAL: string;
      ARTICAL_PIC: string;
      ARTICAL_READED: number;
      ARTICAL_START: Date;
      ARTICAL_STATUS: number;
      ARTICAL_TITAL: string;
      ARTICAL_USER: {
        VALUE_EN: string;
        VALUE_TH: string;
      }
      CREATE_BY: string;
      POLL_ID: string;
    }
  ],
  success: true;
}

interface ResReadArticalById {
  message: string;
  result: [
    {
      updatetime: Date;
    }
  ],
  success: true;
}

interface ResvotePoll {
  message: string;
  result: [
    {
      update: Date;
    }
  ],
  success: true;
}

@Injectable({
  providedIn: 'root'
})
export class ArticalsService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllArticalByType(typeId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllArticalByType>(environment.URL + '/artical/getAllArticalByType?ARTICAL_TYPEID=' + typeId, { headers: headers });
  }

  getDetailByArticalID(id) {
    const headers = new HttpHeaders({ Authorization: this.token })
    const body = {
      ARTICAL_ID: id
    }

    return this.http.post<ResGetDetailByArticalID>(environment.URL + '/artical/getDetailByArticalID', body, { headers: headers });
  }

  readArticalById(id) {
    const headers = new HttpHeaders({ Authorization: this.token })
    const body = {
      ARTICAL_ID: id
    }

    return this.http.post<ResReadArticalById>(environment.URL + '/artical/readArticalById', body, { headers: headers });
  }

  votePoll(pollId, optionId) {
    const headers = new HttpHeaders({ Authorization: this.token })
    const body = {
      POLL_ID: pollId,
      OPTION_ID: optionId
    }

    return this.http.post<ResvotePoll>(environment.URL + '/artical/votePoll', body, { headers: headers });
  }
}
